module.exports = __webpack_public_path__ + "img/ic-check.6e8d18b6.svg";